/**
 * TerminalBoot — one of 5 cockpit loader variants.
 * Ported from landing/components/cockpit/loaders/TerminalBoot.tsx (no Next.js
 * deps; the only change is dropping the 'use client' directive).
 */

import { useEffect, useRef, useState } from 'react';

interface Props {
  progress: number; // 0-100
}

const STATUS_MESSAGES = [
  'Loading market data...',
  'Connecting to ECB...',
  'Parsing EURIBOR rates...',
  'Initializing cockpit...',
];

export default function TerminalBoot({ progress }: Props) {
  const [statusIdx, setStatusIdx] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setStatusIdx((i) => (i + 1) % STATUS_MESSAGES.length);
    }, 400);
    return () => { if (intervalRef.current) {clearInterval(intervalRef.current);} };
  }, []);

  const displayNum = String(Math.round(progress)).padStart(3, '0');

  return (
    <div className="flex flex-col items-center justify-center h-full gap-6">
      <div className="font-mono text-sm tracking-[0.3em] text-txt-tertiary uppercase">
        Credia.pro
      </div>
      <div className="font-mono text-[80px] sm:text-[120px] font-bold leading-none text-txt-primary tabular-nums">
        {displayNum}
      </div>
      <div className="w-64 sm:w-80 h-1 bg-surface-muted overflow-hidden">
        <div
          className="h-full bg-orange"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="font-mono text-xs text-txt-tertiary h-4">
        {STATUS_MESSAGES[statusIdx]}
      </div>
    </div>
  );
}
